import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import classNames from 'classnames';
import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';

import { AppFooter } from '../AppFooter';
import { AppTopbar } from '../AppTopbar';
import { AppMenu } from '../AppMenu';

// import { useValidator } from '../config/useValidator';

const Menu = () => {
    const navigate = useNavigate();
    const { user, loading } = useAuth();

    const perfilBase = [
        {
            label: 'Home',
            items: [
                { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: 'dashboard' },
                { label: 'Mi Perfil', icon: 'pi pi-fw pi-user', to: 'perfil' }
            ]
        },
    ];

    function Acceder() {
        const perms = user?.permissions || [];
        const menu = [...perfilBase];

        const usuariosItems = [];
        if (perms.includes('GESTION_USUARIOS')) {
            usuariosItems.push({ label: 'Gestión de Usuarios', icon: 'pi pi-fw pi-users', to: 'usuario' });
        }
        if (perms.includes('GESTION_ROLES')) {
            usuariosItems.push({ label: 'Gestión de Permisos', icon: 'pi pi-fw pi-lock', to: 'permisos' });
        }

        if (usuariosItems.length > 0) {
            menu.push({
                label: 'Usuarios del Sistema',
                items: usuariosItems
            });
        }

        // Opción de Temas solo para SUPER_ADMINISTRADOR
        if (user?.role === 'SUPER_ADMINISTRADOR') {
            menu.push({
                label: 'Configuración',
                items: [
                    { label: 'Empresa', icon: 'pi pi-fw pi-building', to: 'empresa' },
                    { label: 'Sucursales', icon: 'pi pi-fw pi-sitemap', to: 'sucursales' },
                    { label: 'Tipo de Cambio (Monedas)', icon: 'pi pi-fw pi-dollar', to: 'tipo-cambio' }
                ]
            });
        }

        // Ventas Pro Módulos
        const operacionesItems = [
            { label: 'Punto de Venta (POS)', icon: 'pi pi-fw pi-shopping-cart', to: 'pos' },
            { label: 'API SUNAT', icon: 'pi pi-fw pi-file', to: 'api-sunat' },
            /* { label: 'Gestión de Cajas', icon: 'pi pi-fw pi-wallet', to: 'cajas' }, */
            /* { label: 'Devoluciones', icon: 'pi pi-fw pi-replay', to: 'devoluciones' }, */
            { label: 'Clientes', icon: 'pi pi-fw pi-users', to: 'clientes' },
            { label: 'Gastos', icon: 'pi pi-fw pi-money-bill', to: 'gastos' },
        ];

        

        menu.push({
            label: 'Operaciones',
            items: operacionesItems
        });

        menu.push({
            label: 'Inventario',
            items: [
                { label: 'Categorías', icon: 'pi pi-fw pi-tags', to: 'categorias' },
                { label: 'Almacenes', icon: 'pi pi-fw pi-building', to: 'almacenes' },
                { label: 'Productos', icon: 'pi pi-fw pi-box', to: 'productos' }
                /* { label: 'Kardex', icon: 'pi pi-fw pi-list', to: 'kardex' } */
            ]
        });

        menu.push({
            label: 'Reportes y Logs',
            items: [
                { label: 'Reportes y Cierres', icon: 'pi pi-fw pi-chart-bar', to: 'reportes' },
                { label: 'Auditoría (Logs)', icon: 'pi pi-fw pi-history', to: 'auditoria' }
            ]
        });

        return menu;
    }

    const menuClickRef = useRef(false);
    const mobileTopbarMenuClickRef = useRef(false);
    PrimeReact.ripple = true;
    const toast = useRef(null);

    // const footerRef = useRef(null);
    // const isValid = useValidator(footerRef);
    const menu = Acceder();

    const stylespj = {
        body: {
            height: '100%',
            width: '100%',
            backgroundColor: 'var(--bg-page)',
            backgroundImage: 'none',
        }
    }

    const [layoutMode] = useState('static');
    const [layoutColorMode] = useState('light');
    const [inputStyle] = useState('outlined');
    const [ripple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);

    useEffect(() => {
        if (!loading && !user) {
            navigate('/admin/login');
        }
        // Si es un cliente, redirigir a la tienda
        if (!loading && user && user.userType === 'CLIENTE') {
            navigate('/tienda');
            return;
        }
        document.documentElement.style.fontSize = 12 + 'px';
    }, [user, loading, navigate]);

    if (loading) {
        return <div>Cargando...</div>;
    }

    if (!user) {
        return null;
    }

    const onWrapperClick = (event) => {
        if (!menuClickRef.current) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClickRef.current) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClickRef.current = false;
        menuClickRef.current = false;
    }

    const onSidebarClick = () => {
        menuClickRef.current = true;
    }

    const isDesktop = () => {
        return window.innerWidth >= 992;
    }

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    }

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClickRef.current = true;
        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    }

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClickRef.current = true;
        event.preventDefault();
    }

    const onToggleMenuClick = (event) => {
        menuClickRef.current = true;

        if (isDesktop()) {
            if (layoutMode === 'overlay') {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            }
            else if (layoutMode === 'static') {
                setStaticMenuInactive((prevState) => !prevState);
            }
        }
        else {
            setMobileMenuActive((prevState) => !prevState);
        }
        event.preventDefault();
    }

    const wrapperClass = classNames('layout-wrapper', {
        'layout-overlay': layoutMode === 'overlay',
        'layout-static': layoutMode === 'static',
        'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
        'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
        'layout-mobile-sidebar-active': mobileMenuActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': ripple === false,
        'layout-theme-light': layoutColorMode === 'light'
    });

    return (
        <div className={wrapperClass} onClick={onWrapperClick} style={stylespj.body} >
            <Toast ref={toast} />
            <Tooltip target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
            <AppTopbar onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode}
                mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />
            <div className="layout-sidebar" onClick={onSidebarClick} >
                {/* {isValid && <AppMenu model={menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} userRole={user.role} />} */}
                <AppMenu model={menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} userRole={user.role} />
            </div>
            <div className="layout-main-container">
                <div className="container">
                    {/* {isValid && <Outlet />} */}
                    <Outlet />
                </div>
                {/* {isValid && <AppFooter ref={footerRef} />} */}
                <AppFooter />
            </div>
        </div>
    );
}

export default Menu;
